import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { ErrorInfo } from 'register-partners-js/utils/error-info';

export default class OrderSummaryRoute extends Route {
  mainLayout = MainLayout;

  @service router;
  @service sentry;

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');
    return { organization, registration };
  }

  setupController(controller, transition) {
    super.setupController(...arguments);

    controller.getPricePlanTask.perform().catch(error => {
      if (ErrorInfo.for(error).shouldSendToSentry) {
        this.sentry.captureException(error);
      }
      this.send('error', new Error(error), transition);
      transition?.abort();
    });
  }
}
